/**
 * Zakładki — progressive enhancement.
 *
 * Bez JS: menu jest bezczynne, a panele leżą w flow jeden pod drugim
 * (treść w pełni dostępna). Ten skrypt dodaje:
 *  - przełączanie paneli z przenikaniem (klasy is-active + CSS),
 *  - role tab/tablist/tabpanel + ARIA i strzałki klawiatury — dopiero
 *    tutaj, bo bez działającego przełączania role by kłamały,
 *  - doscrollowanie aktywnej etykiety, gdy menu się nie mieści
 *    (overflow-x na wąskich ekranach / przy wielu zakładkach).
 */
(function () {
    var SEL_BLOCK = '.wp-block-avangardo-tabs';
    var SEL_BTN = '.wp-block-avangardo-tabs__menuBtn';
    var SEL_PANEL = '.wp-block-avangardo-tabs__panel';
    var SEL_MENU = '.wp-block-avangardo-tabs__menu';

    function initBlock(block, blockIndex) {
        var menu = block.querySelector(SEL_MENU);
        var buttons = Array.prototype.slice.call(block.querySelectorAll(SEL_BTN));
        // :scope — zakładki mogą kiedyś zawierać inne bloki z panelami;
        // bierzemy tylko bezpośrednie panele tego bloku
        var panels = Array.prototype.slice.call(
            block.querySelectorAll(':scope > .wp-block-avangardo-tabs__panels > ' + SEL_PANEL)
        );

        if (!menu || buttons.length < 2 || panels.length !== buttons.length) return;

        var current = 0;

        menu.setAttribute('role', 'tablist');
        buttons.forEach(function (btn, i) {
            var tabId = 'avTabs-' + blockIndex + '-tab-' + i;
            var panelId = 'avTabs-' + blockIndex + '-panel-' + i;
            btn.id = tabId;
            btn.setAttribute('role', 'tab');
            btn.setAttribute('aria-controls', panelId);
            panels[i].id = panelId;
            panels[i].setAttribute('role', 'tabpanel');
            panels[i].setAttribute('aria-labelledby', tabId);
            btn.addEventListener('click', function () {
                activate(i);
            });
        });

        function sync() {
            buttons.forEach(function (btn, i) {
                var active = i === current;
                btn.classList.toggle('is-active', active);
                btn.setAttribute('aria-selected', active ? 'true' : 'false');
                btn.tabIndex = active ? 0 : -1;
            });
            panels.forEach(function (panel, i) {
                panel.classList.toggle('is-active', i === current);
                panel.setAttribute('aria-hidden', i === current ? 'false' : 'true');
            });
        }

        function activate(i) {
            if (i === current || !panels[i]) return;
            current = i;
            sync();
            // przewijalne menu: aktywna etykieta zawsze w kadrze
            if (menu.scrollWidth > menu.clientWidth) {
                buttons[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
            }
        }

        // roving tabindex: strzałki klawiatury krążą po zakładkach (z zawinięciem)
        menu.addEventListener('keydown', function (e) {
            if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
            var next = e.key === 'ArrowRight'
                ? (current + 1) % buttons.length
                : (current - 1 + buttons.length) % buttons.length;
            activate(next);
            buttons[next].focus();
            e.preventDefault();
        });

        sync();
        // włącza CSS-owe sztaplowanie paneli i fade; przed tą klasą
        // panele leżą w flow (stan bez JS)
        block.classList.add('is-enhanced');
    }

    function init() {
        document.querySelectorAll(SEL_BLOCK).forEach(initBlock);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
